import { Button, CircularProgress } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import channelPagesRoleManagement from '../../staticRoleManagement/channelPagesRoleManagement'
import useStyles from './styles/AccommodationFooter.styles'

interface FooterProps {
  onClick: () => void
  disabled: boolean
  loading: boolean
}

export const Footer: React.FC<FooterProps> = ({
  onClick,
  disabled,
  loading
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))
  const hasAccessToModifyChannelMapping = channelPagesRoleManagement
    .find((item) => item.route === '/channels/:id/:channelCode/:page')
    ?.tabs?.find((routeTabItem) => routeTabItem.params.page === 'mapping')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  return (
    <div className={classes.footer}>
      <Button
        variant="contained"
        color="primary"
        size="medium"
        fullWidth={matches}
        onClick={onClick}
        disabled={disabled || !hasAccessToModifyChannelMapping}>
        {getTranslate('Save Changes')}
        {loading && (
          <CircularProgress className={classes.circularProgress} size={16} />
        )}
      </Button>
    </div>
  )
}
